import type { JSX } from 'react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@feathr/components';

import * as styles from './MetaPrerequisites.css';

function MetaPrerequisites(): JSX.Element {
  const { t } = useTranslation();
  const prerequisites = useMemo(
    () => [
      t('A Facebook Business Manager account'),
      t(
        'Admin access to the Business Manager account that includes the Facebook and Instagram pages you want to use',
      ),
    ],
    [t],
  );

  return (
    <Alert
      className={styles.alert}
      description={prerequisites}
      name={'meta-prerequisites-alert'}
      title={t('Before you begin, make sure you have the following:')}
      type={'info'}
    />
  );
}

export default MetaPrerequisites;
